import React, { useContext, useEffect, useState } from 'react';
import styles from '../styles.module.scss';
import axiosInstance from '../../../../../../axios_instance';
import {
  IsAdminContext,
  NumberOfEducationContext,
  UserEducationDataContext,
} from '../../../../../../context';
import { Row, Skeleton } from 'antd';
import AddEducation from './add-education';
import EducationDetail from './education-detail-view';
import { useParams } from 'react-router-dom';
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import swal from "sweetalert";
import { reorder } from '../../../../../../utils/helper';




const EducationCard: React.FC<any> = (): JSX.Element => {
  const [userEducationData, setUserEducationData] = useState<any>([]);
  const [addNew, setAddNew] = useState<boolean>(false);
  const [message, setMessage] = useState<string>();
  const isAdmin = useContext(IsAdminContext);
  const { employeeId } = useParams();
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const { numberOfEducation, setNumberOfEducation } = useContext(NumberOfEducationContext)

  useEffect(() => {
    let url = '';
    if (isAdmin === '1') {
      url = '/api/v1/profile/admin/user-profiles/' + employeeId + '/educations';
    } else {
      url = '/api/v1/profile/user-profiles/educations';
    }
    axiosInstance.get(url).then((response) => {

      const orderedEducations = response.data.order.map((educationId: number) =>
        response.data.educations.find((education: any) => education.education_id === educationId)
      ).filter((item: any) => item !== undefined);
      setUserEducationData(orderedEducations);
      setNumberOfEducation(orderedEducations.length);
    }).catch((error) => {
      setMessage("Something went wrong!Items couldn't be loaded!")
    }).finally(() => {
      setIsLoading(false)
    });
  }, []);

  const onDragEnd = (result: any) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    if (userEducationData.length < 2) {
      return;
    }
    if (result.source.index === result.destination.index) {
      return;
    }

    const items = reorder(
      userEducationData,
      result.source.index,
      result.destination.index
    );
    const order_list = items.map((item: any) =>
      item.education_id
    );
    setUserEducationData(
      items
    );

    const payload: any = {
      type: "educations",
      updated_reorder_list: order_list
    };
    if (isAdmin === '1') {
      payload.profile_id = employeeId;
    }

    axiosInstance.post("/api/v1/reorder", payload).then((response) => {
      swal({
        title: 'Updated',
        text: 'Order of educations has been updated',
        icon: "success",
      }).then((willRefresh) => {
        console.log()
      });
    }).catch((error) => {
      swal({
        title: 'Failed',
        text: 'Order of educations could not be updated',
        icon: "error",
      }).then((willRefresh) => {
        console.log()
      });
    })

  }

  return (
    <div style={{ position: 'relative' }}>
      <UserEducationDataContext.Provider
        value={{ userEducationData, setUserEducationData }}
      >
        {isLoading ? <Skeleton active /> :
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable">
              {(provided: any, snapshot: any) => (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                >
                  {userEducationData.map((item: any, index: any) => (
                    <Draggable key={`row_${item.education_id}`} draggableId={`row_${item.education_id}`} index={index}>
                      {(provided: any, snapshot: any) => (
                        <div

                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                        >
                          <EducationDetail
                            key={index}
                            {...item}
                          />
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        }
        {message ? <p style={{ color: "red" }}>{message}</p> : <></>}

        {addNew ? <AddEducation {...{ setAddNew: setAddNew }} /> : <></>}
      </UserEducationDataContext.Provider>
      <Row style={{ position: 'relative' }}>
        <p
          className={styles['add-new']}
          onClick={(e) => {
            setAddNew(true);
          }}
        >
          Add New (+)
        </p>
      </Row>
    </div >
  );
};

export default EducationCard;
